import { useCallback } from 'react'

import { getConfiguredTenantCode } from '@/config/tenant-site'
import { catalogParticipationHref } from '@/shared/lib/catalog-participation'
import { useAuthConfig } from './useAuthConfig'

export function useCatalogParticipationHref() {
  const { config } = useAuthConfig()
  const currentCode = config?.tenant_code ?? getConfiguredTenantCode()

  return useCallback(
    (tenantCode: string | undefined, path: string) =>
      catalogParticipationHref(tenantCode, path, currentCode),
    [currentCode],
  )
}
